import React from 'react'
import { LDialog, LComboBox, LFade } from "@loffa/gpp-modules";
import KeyBasedLButton from '../../../../../../Shared/KeyBasedLButton';
import styles from "../../TemplateManagement.module.css"

//used for creating a template map for a client - simple dropdown
export default function SelectClientModal({selectedClient, showClientSelect, clients, onClientSelect, onClientSelectClose, onClientSelectConfirm}) {
  return (
    <LFade transitionEnterDuration={300}>
        {showClientSelect && (
          <div>
            <LDialog
              width="400"
              title="Create File Map for Client"
              subtitle="Select a Client"
              body={
                <div>
                  <LComboBox
                    style={{ width: "100%" }}
                    data={clients}
                    textField="formattedName"
                    valueField="clientValuePayload"
                    placeholder="Select Client"
                    onChange={onClientSelect}
                  ></LComboBox>
                </div>
              }
              actionLayout="stretched"
              action={selectedClient ? (
                  <KeyBasedLButton
                    themeColor="primary"
                    className={`green ${styles.stretchButton}`}
                    onClick={onClientSelectConfirm}
                    parentKey={selectedClient}
                    buttonText={"Next: Select Template"}
                  >
                  </KeyBasedLButton>
                ) : <KeyBasedLButton
                    disabled={true}
                    className={`${styles.stretchButton}`}
                    parentKey={selectedClient}
                    buttonText={"Next: Select Template"}
                  >
                  </KeyBasedLButton>
              }
              actionCloseButton={onClientSelectClose}
              actionOverlay={onClientSelectClose}
            />
          </div>
        )}
      </LFade>
  )
}